import { Pipe, PipeTransform } from '@angular/core';
import { TelemetryItem } from '../services/state.service';


@Pipe({
    name: 'orderedTelemetry'
})
export class OrderedTelemetryPipe implements PipeTransform {
    transform(telemetryItems: TelemetryItem[], order: string[]): TelemetryItem[] {
        if (!Array.isArray(telemetryItems) || !Array.isArray(order)) {
            return [];
        }

        const orderedArray = telemetryItems.filter(t => order.includes(t.name));

        orderedArray.sort((a: TelemetryItem, b: TelemetryItem) => {
            const first = order.findIndex(o => o === a.name);
            const second = order.findIndex(o => o === b.name);
            if (first < second) {
                return -1;
            } else if (first > second) {
                return 1;
            } else {
                return 0;
            }
        });
        return orderedArray;
    }
}
